import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPlayRounded = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.6968 5.53108L2.44717 0.65393C1.77689 0.257852 0.750366 0.642212 0.750366 1.62186V11.3738C0.750366 12.2527 1.70423 12.7823 2.44717 12.3417L10.6968 7.46693C11.4327 7.03336 11.4351 5.96465 10.6968 5.53108Z" })
});
export default SvgIconPlayRounded;
